<template>
  <div class="">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="申请修改"
      fontSize="0.32rem"
    />
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div v-show="formData.cardType === 0">
        <div class="pic_main">
          <h4>上传房产证图片<span>（最多3张）</span></h4>
          <div class="pic_con">
            <van-uploader v-model="houseCardPic" :before-read="beforeRead" :after-read="afterRead1" :max-count="3" />
          </div>
        </div>
        <div class="pic_main">
          <h4>上传土地证图片<span>（最多3张）</span></h4>
          <div class="pic_con">
            <van-uploader v-model="landCardPic" :before-read="beforeRead" :after-read="afterRead2" :max-count="3" />
          </div>
        </div>
      </div>
      <div v-show="formData.cardType === 1">
        <div class="pic_main">
          <h4>上传不动产证图片<span>（最多3张）</span></h4>
          <div class="pic_con">
            <van-uploader v-model="bdcPic" :before-read="beforeRead" :after-read="afterRead3" :max-count="3" />
          </div>
        </div>
      </div>
      <div class="pic_main">
        <h4>上传身份证<span>（最多12张）</span></h4>
        <div class="pic_con">
          <van-uploader v-model="cardPic" :before-read="beforeRead" :after-read="afterRead4" :max-count="12" />
        </div>
      </div>
      <div class="pic_main">
        <h4>错误信息描述<span>（选填）</span></h4>
        <van-field
          v-model="formData.applyMsg"
          name="applyMsg"
          rows="4"
          label=""
          type="textarea"
          maxlength="100"
          placeholder="在此输入..."
          show-word-limit
        />
      </div>
      <div class="pad_b"></div>
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      area: '',
      cardType: '',
      formData: {
        applyMsg:'',
        cardType: '',
        houseMainId: ''
      },
      houseCardPic: [],
      landCardPic: [],
      bdcPic: [],
      cardPic: [],
      flag: true,
    };
  },
  components: {
    topHeader
  },
  mounted() {
    this.formData.houseMainId = this.$route.query.id;
    const text = decodeURI(decodeURI(this.$route.query.type));
    if(text.includes('不动产')) {
      this.formData.cardType = 1
    } else {
      this.formData.cardType = 0
    }
  },
  methods: {
    afterRead1(file) {
      console.log(file)
      this.createImage(file.file, 'houseCardPic')
    },
    afterRead2(file) {
      this.createImage(file.file, 'landCardPic')
    },
    afterRead3(file) {
      this.createImage(file.file, 'bdcPic')
    },
    afterRead4(file) {
      this.createImage(file.file, 'cardPic')
    },
    createImage(file, list) {
      let reader = new FileReader();
      let self = this
      reader.onload = e => {
        let result = e.target.result
        let img = new Image()
        img.src = result
        if(result.length/1024 > 10){
          img.onload = function() {
          //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
              // this.firImg = self.compress(img, 0.4)
              // console.log(this.firImg)
              self[list][self[list].length - 1].content = self.compress(img, 0.4)
          }
        }
      };
      // 读取图像
      reader.readAsDataURL(file);
    },
    // 压缩图片
    compress(img, size) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = img.src.length
      if (img.width > 1000 && img.width >= img.height) {
        img.height *= 1000 / img.width;
        img.width = 1000;
      }
      //宽小于高的情况
      if (img.height > 1000 && img.height > img.width) {
        img.width *= 1000 / img.height;
        img.height = 1000;
      }
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      //绘制图片
      ctx.drawImage(img, 0, 0, img.width, img.height);
      //进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', size)
      return ndata
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 6000 * 1024) {
        this.$toast('文件大小不得超过6M');
        return false;
      }
      return true;
    },
    onSubmit(values) {
      if(this.formData.cardType === 0 && !this.houseCardPic.length) {
        this.$toast('房产证图片不得为空');
        return;
      } else if(this.formData.cardType === 0 && !this.landCardPic.length) {
        this.$toast('土地证图片不得为空');
        return;
      } else if(this.formData.cardType === 1 && !this.bdcPic.length) {
        this.$toast('不动产证图片不得为空');
        return;
      } else if(!this.cardPic.length) {
        this.$toast('身份证图片不得为空');
        return;
      }
      const imgList = {
        houseCardPic: this.setArrImg('houseCardPic'),
        landCardPic: this.setArrImg('landCardPic'),
        bdcPic: this.setArrImg('bdcPic'),
        cardPic: this.setArrImg('cardPic'),
      };
      if(!this.flag) {
        return
      }
      this.flag = false;
      this.$http.post('cms/houseDataChange/reg/infoAdd.do',qs.stringify({
        entity: JSON.stringify(this.formData),
        area: this.$route.query.area,
        imgList: JSON.stringify(imgList)
      })).then(res => {
        if(res.success) {
          this.$dialog.alert({
            title: '提示',
            message: res.msg
          }).then(() => {
            this.$router.replace('/applyRecord')
          });
        } else {
          this.flag = true;
        }
      }).catch(() => {
        this.$dialog.alert({
            title: '提示',
            message: res.msg
          })
        this.flag = true;
      })
    },
    setArrImg(type) {
      const arr = [];
      this[type].forEach(item => {
        arr.push(item.content.split(',')[1]);
      });
      return arr;
    },
  },
};
</script>
<style lang="less" scoped>
h3{
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0 auto 0.6rem;
}
.form_con{
  padding: 0.3rem 0rem;
}
.b_btn{
  display: block;
  position: absolute;
  width: 3.28rem;
  line-height: 0.84rem;
  border-radius: 0.08rem;
  color: #FF3232;
  border: 1px solid currentColor;
  font-size: 0.28rem;
  text-align: center;
  left: 50%;
  margin-left: -1.64rem;
  bottom: 0.35rem;
}
.pic_main{
  padding: 10px 12px;
  h4{
    font-size: 14px;
    margin-bottom: 16px;
    padding: 0 2px;
    span{
      color: #999;
      margin-left: 0.1rem;
    }
  }
  .pic_con{
    border-bottom: 1px solid #f5f5f5;
  }
  /deep/
  .van-field{
    border: 1px solid #f5f5f5;
    box-sizing: border-box;
  }
}
/deep/
.van-uploader{
  margin-right: -8px;
}
.pad_b{
  padding-bottom: 1.68rem;
}
.btn_con{
  position: fixed;
  bottom: 0;
  background-color: #fff;
  z-index: 9;
  padding: 0.4rem 0;
  left: 0;
  right: 0;
  /deep/
  .van-button{
    height: 0.88rem;
    width: 7.04rem;
    margin: 0 auto;
    border-radius: 0.08rem;
  }
}
</style>